export default __webpack_public_path__ + "static/fnGGEGzE-b0f5f2b76683d1882c78e6c7c8de2d2b.svg";